/**
 * vue模組
  * @enum {string}
 */
enum modules$ {

	/** 頂欄 */
	topBar = "TopBar",
	/** 驗證碼 */
	captcha = "Captcha",
	/** 主題樣式 */
	themeStyle = "ThemeStyle",
	/** 帳號管理 */
	accMgmt = "AccMgmt",
	/** SignalR */
	signalR = "SignalR",
	/** 上傳檔案 */
	upload = "Upload",
	/** 上傳檔案列表 */
	uploadList = "UploadList",
	/** 訊息視窗 */
	messenger = "Messenger",
	/** Toast視窗 */
	toaster = "Toaster",
	/** 佔用載入區 */
	loading = "Loading",
	/** 登入頁 */
	login = "Login",
	/** 主框 */
	main = "Main",
	/** 主頁 */
	home = "Home",
	/** 示範頁 */
	demo = "Demo",
	/** webRtcPhone */
	webRtcPhone = "WebRtcPhone",
	/** WebPhone */
	webPhone = "WebPhone",
	/** WebRTC 統計監控頁 */
	webRtcStatsMonitor = "WebRtcStatsMonitor",
	/** 排程監控頁 */
	scheduleMonitor = "ScheduleMonitor",
	/** 通訊監控頁 */
	commMonitor = "CommMonitor",
	/** 主機資源監控 */
	hostMonitor = "HostMonitor",
	/** 常用連結 */
	favLinks ="FavLinks"
}

export default modules$;